import { render, staticRenderFns } from "./sensorDetail.vue?vue&type=template&id=66bda9c1"
import script from "./sensorDetail.vue?vue&type=script&lang=js"
export * from "./sensorDetail.vue?vue&type=script&lang=js"
import style0 from "./sensorDetail.vue?vue&type=style&index=0&id=66bda9c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports